import React from 'react'
import { useLocation } from 'react-router-dom'

function ChatIcon({ size = 28 }) {
  const location = useLocation()
  const isActive = location.pathname.startsWith('/chat')
  const color = isActive ? '#FFFFFF' : '#8F9DAC'

  return (
    <svg width={size} height={size} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M25.6667 13.4946C25.6667 19.6584 20.4426 24.6558 14 24.6558C13.2425 24.6568 12.4871 24.5867 11.743 24.4471C11.2074 24.3464 10.9396 24.2961 10.7526 24.3247C10.5656 24.3533 10.3007 24.4942 9.77082 24.776C8.27183 25.5731 6.52394 25.8547 4.84296 25.542C5.48186 24.7561 5.91821 23.8132 6.11074 22.8024C6.22741 22.1841 5.93833 21.5835 5.50537 21.1438C3.53888 19.1469 2.33333 16.4561 2.33333 13.4946C2.33333 7.33099 7.55741 2.3335 14 2.3335C14.799 2.3335 15.5794 2.41038 16.3333 2.55682'
        stroke={color}
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M26.8333 6.41683C26.8333 8.672 25.0052 10.5002 22.75 10.5002C20.4948 10.5002 18.6667 8.672 18.6667 6.41683C18.6667 4.16166 20.4948 2.3335 22.75 2.3335C25.0052 2.3335 26.8333 4.16166 26.8333 6.41683Z'
        fill={color}
      />
      <path
        d='M13.9947 14H14.0052M18.6562 14H18.6667M9.33333 14H9.3438'
        stroke={color}
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}

export default ChatIcon
